import { McpRemote } from './isApiEntityMcpServer';

type VscodeMcpInstallPayload = {
  name: string;
  type: string;
  url: string;
};

const buildVscodeInstallPayload = (name: string, remote: McpRemote): VscodeMcpInstallPayload => ({
  name,
  type: remote.type,
  url: remote.url,
});

export const buildVscodeInstallUrl = (name: string, remote: McpRemote): string => {
  const payload = buildVscodeInstallPayload(name, remote);
  return `vscode:mcp/install?${encodeURIComponent(JSON.stringify(payload))}`;
};

const prettyPrintWithTwoSpacesIndentation = 2;
export const buildMcpJsonSnippet = (name: string, remote: McpRemote): string =>
  JSON.stringify(
    {
      servers: {
        [name]: {
          type: remote.type,
          url: remote.url,
        },
      },
    },
    null, // no custom filtering/transformation
    prettyPrintWithTwoSpacesIndentation,
  );
